import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.835 11.31a.9.9 0 0 1 0 1.172c-1.146 1.354-4.211 4.64-7.525 5.415-3.587.837-9.8-2.674-11.537-3.716a.96.96 0 0 1-.463-.832v-2.905c0-.34.17-.656.463-.832C6.51 8.57 12.723 5.06 16.31 5.897c3.314.773 6.379 4.06 7.525 5.414m-5.525.586a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.328 20.14a1.5 1.5 0 0 1-2.027-1.397l-.011-2.568c.917.482 2.017 1.02 3.183 1.494.922.375 1.9.717 2.871.964zm5.81-2.18c-2.668-.32-5.849-1.834-7.853-2.921l-.004-.768 8.03 3.625zM6.281 9.322l.002-.569c2.004-1.087 5.185-2.6 7.853-2.922l.176.066zm6.063-4.164c-.97.247-1.949.59-2.871.965a37 37 0 0 0-3.184 1.494l.012-2.566a1.5 1.5 0 0 1 2.027-1.397z"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "2",
      cy: "2",
      r: "2",
      fill: "currentColor",
      transform: "matrix(0 1 1 0 -1.689 9.896)"
    }, null, -1)
  ]))]))
}
export default { render: render }